import { resourceHeaders } from './resource-actions.factory';

export default [
  '$resource',
  'unAuthedInterceptor',
  ConnectionSourceResource
];

export function ConnectionSourceResource($resource, unAuthedInterceptor) {
  return $resource(
    '/api/v2/sources/available',
    {},
    {
      'fetchAvailable': {
        method: 'GET',
        headers: resourceHeaders.get,
        interceptor: unAuthedInterceptor,
      }
    },
  );
}